import { Dropdown, DropdownMenu, DropdownToggle } from "@doar/components";
import { useWindowSize } from "@doar/shared/hooks";
import classNames from "classnames";
import { FC, useState } from "react";
import { ChevronDown, ChevronUp } from "react-feather";
import { StyledDropdownItem, StyledDropdownWrap } from "./style";

const items = [
    {
        id: 1,
        name: "In 1 day",
    },
    {
        id: 2,
        name: "In 2 days",
    },
    {
        id: 3,
        name: "Next week",
    },
    {
        id: 4,
        name: "Next month",
    },
    {
        id: 5,
        name: "Custom",
    },
];

interface Props {
    onChange: (name: string) => void;
    disabled?: boolean;
}

const ReminderSelection: FC<Props> = ({ onChange, disabled }) => {
    const [show, setShow] = useState(false);
    const [value, setValue] = useState("");
    const onSelectOption = (id: number, name: string) => {
        setShow(false);
        setValue(name);
        onChange(name);
    };
    const { width } = useWindowSize();

    return (
        <StyledDropdownWrap>
            <Dropdown
                className={classNames({
                    resReminder: width && width < 1700,
                })}
                direction="down"
                isShow={show}
                getState={(state) => setShow(state)}
            >
                <DropdownToggle
                    variant="outlined"
                    className="dropdownToggle"
                    disabled={disabled}
                >
                    <div className="value">{value || "Set reminder"}</div>
                    <div className="selectionArrow">
                        {show ? <ChevronUp /> : <ChevronDown />}
                    </div>
                </DropdownToggle>
                <DropdownMenu show className="dropdownMenu">
                    {items.map((item) => {
                        return (
                            <StyledDropdownItem
                                key={item.id}
                                onClick={() =>
                                    onSelectOption(item.id, item.name || "")
                                }
                            >
                                {item.name}
                            </StyledDropdownItem>
                        );
                    })}
                </DropdownMenu>
            </Dropdown>
        </StyledDropdownWrap>
    );
};

export default ReminderSelection;
